import React from 'react';

function TransitionsPreview() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="108"
      viewBox="0 0 108 108"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path fill="#FFF" d="M0 0H108V108H0z" />
        <path
          fill="#EFEFEF"
          d="M93 98a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V73a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V44a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79z"
        />
        <path fill="currentColor" d="M52 0H108V108H52z" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M80.19 65.983a1.333 1.333 0 001.048-1.313V54.615h6.147c.308 0 .615-.316.615-.632 0-.227-.086-.405-.25-.514l-.01-.01-6.877-7.081c-.442-.504-1.23-.504-1.729 0l-6.945 7.14c-.202.208-.24.435-.125.702.068.237.308.375.567.375h6.148V64.71c0 .77.682 1.403 1.412 1.274z"
          transform="rotate(-90 80 56)"
        />
      </g>
    </svg>
  );
}

export default TransitionsPreview;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/TransitionsPreview.js